import { lazy, Suspense, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
import { loginConfirmedAction, LOGOUT_ACTION } from "./store/actions/AuthActions";

import "./assets/css/style.css";

const Index = lazy(() => import("./jsx/index"));
const Login = lazy(() => import("./jsx/pages/Login"));
const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const ActivateAccount = lazy(() => import("./jsx/pages/ActivateAccount"));

const hasStoredToken = () => !!localStorage.getItem("tokenLogin");

function AppRoutes({ authenticated }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("tokenLogin");

    if (token && !authenticated) {
      dispatch(
        loginConfirmedAction({
          idToken: token,
          tokenLogin: token,
          email: localStorage.getItem("email") || "",
        })
      );
      return;
    }

    if (!token) {
      dispatch({ type: LOGOUT_ACTION });
    }
  }, [authenticated, dispatch]);

  useEffect(() => {
    const publicPaths = ["/login", "/page-register", "/page-forgot-password"];
    const isPublic =
      publicPaths.includes(location.pathname) ||
      location.pathname.startsWith("/activate-account");

    if (!authenticated && !isPublic) {
      navigate("/login", { replace: true });
      return;
    }

    if (authenticated && (location.pathname === "/login" || location.pathname === "/")) {
      navigate("/dashboard", { replace: true });
    }
  }, [authenticated, location.pathname, navigate]);

  if (authenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="/page-register" element={<Navigate to="/dashboard" replace />} />
        <Route path="/page-forgot-password" element={<Navigate to="/dashboard" replace />} />
        <Route path="/*" element={<Index />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/page-register" element={<SignUp />} />
      <Route path="/page-forgot-password" element={<ForgotPassword />} />
      <Route path="/activate-account/:token" element={<ActivateAccount />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App(props) {
  const authenticated = props.isAuthenticated || hasStoredToken();

  return (
    <Suspense
      fallback={
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      }
    >
      <AppRoutes authenticated={authenticated} />
    </Suspense>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(App);
